import { Component } from "react";
import { Link } from "react-router-dom";

class KitInsightsSection extends Component {
  render() {
    // Note: Backend remapping can be done?
    const insights = this.props.insights || {
      leftCard: {
        tag: "#STEMeducation",
        title: "Start Your Robotics Journey",
        description:
          "Introduce kids to the world of automation and robotics through hands-on learning with the XLP Advanced Learning Kit. Start Here.",
        image: "/assets/misc/honda_robo_knockoff.webp",
      },
      topRightCard: {
        tag: "#FutureSkills",
        title: "Learning by Building",
        description:
          "Encourage creativity and problem-solving as kids build real models and understand how robotics systems work.",
        image: "/assets/misc/kids_robot.webp",
      },
      bottomRightCard: {
        tag: "#YoungInnovators",
        title: "Build. Explore. Innovate.",
        description:
          "Discover how experimenting with robotics components can inspire young minds to think like future engineers.",
        image: "/assets/misc/kids_robots_2.webp",
      },
    };

    return (
      <section className="py-5 bg-white">
        <div className="container py-4">
          {/* Section Header */}
          <div className="mb-5">
            <h2
              className="display-6 text-dark mb-2"
              style={{ letterSpacing: "-0.5px" }}
            >
              XLP Kit Insights
            </h2>
            <p className="text-secondary mb-0" style={{ fontSize: "16px" }}>
              Discover robotics learning tips, STEM project ideas, and the
              latest innovations in automation and hands-on technology education
              with XLP Kits.
            </p>
          </div>

          {/* Asymmetrical Grid Layout */}
          <div className="row g-4">
            {/* LEFT COLUMN: Tall Hero Card */}
            <div className="col-12 col-lg-6">
              <Link
                to={insights.leftCard.link}
                className="card border-0 rounded-4 overflow-hidden text-decoration-none d-block position-relative h-100 shadow-sm custom-card-hover"
                style={{
                  minHeight: "480px",
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0) 50%, rgba(0,0,0,0.85) 100%), url(${insights.leftCard.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Content pinned to the bottom */}
                <div className="position-absolute bottom-0 start-0 p-4 p-md-5 w-100">
                  <span
                    className="badge mb-3 px-3 py-2 fw-medium rounded-2 text-white"
                    style={{ backgroundColor: "#e45d3c", fontSize: "13px" }}
                  >
                    {insights.leftCard.tag}
                  </span>
                  <h3 className="text-white fw-bold mb-2">
                    {insights.leftCard.title}
                  </h3>
                  <p
                    className="text-light mb-0 small"
                    style={{ opacity: "0.9", lineHeight: "1.5" }}
                  >
                    {insights.leftCard.description}
                  </p>
                </div>
              </Link>
            </div>

            {/* RIGHT COLUMN: Stacked Cards */}
            <div className="col-12 col-lg-6 d-flex flex-column gap-4">
              {/* Top Right Card */}
              <Link
                to={insights.topRightCard.link}
                className="card border-0 rounded-4 overflow-hidden text-decoration-none d-block position-relative flex-grow-1 shadow-sm custom-card-hover"
                style={{
                  minHeight: "230px",
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0) 30%, rgba(0,0,0,0.85) 100%), url(${insights.topRightCard.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="position-absolute bottom-0 start-0 p-4 w-100">
                  <span
                    className="badge mb-2 px-2 py-1 fw-medium rounded-2 text-white"
                    style={{ backgroundColor: "#e45d3c", fontSize: "12px" }}
                  >
                    {insights.topRightCard.tag}
                  </span>
                  <h4
                    className="text-white fw-bold mb-1"
                    style={{ fontSize: "20px" }}
                  >
                    {insights.topRightCard.title}
                  </h4>
                  <p
                    className="text-light mb-0 small"
                    style={{ opacity: "0.9", fontSize: "13px" }}
                  >
                    {insights.topRightCard.description}
                  </p>
                </div>
              </Link>

              {/* Bottom Right Card */}
              <Link
                to={insights.bottomRightCard.link}
                className="card border-0 rounded-4 overflow-hidden text-decoration-none d-block position-relative flex-grow-1 shadow-sm custom-card-hover"
                style={{
                  minHeight: "230px",
                  backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0) 30%, rgba(0,0,0,0.85) 100%), url(${insights.bottomRightCard.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="position-absolute bottom-0 start-0 p-4 w-100">
                  <span
                    className="badge mb-2 px-2 py-1 fw-medium rounded-2 text-white"
                    style={{ backgroundColor: "#e45d3c", fontSize: "12px" }}
                  >
                    {insights.bottomRightCard.tag}
                  </span>
                  <h4
                    className="text-white fw-bold mb-1"
                    style={{ fontSize: "20px" }}
                  >
                    {insights.bottomRightCard.title}
                  </h4>
                  <p
                    className="text-light mb-0 small"
                    style={{ opacity: "0.9", fontSize: "13px" }}
                  >
                    {insights.bottomRightCard.description}
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default KitInsightsSection;
